import CategoryFormConfig from "./form";
import { CategoryFormData } from "@/formTypes/CategoryFormDataType";
import GenericForm from "../GenericForm";
import { CategoryApi, CategoryDataType } from "@/api/CategoryApi";
import { useRef } from "react";
import { DynamicFormRef } from "@mavichpe/dynamic-forms";
import { ProductDataType } from "@/api/ProductsApi";
import SearchCabysOffCanvas from "@components/layout/Offcanvas/SearchCabysOffCanvas";

type CategoryFormProps = {
  id?: string;
  formId: string,
  saveRedirectUrl: string
}

const CategoryForm = (props: CategoryFormProps) => {
  const formRef = useRef<DynamicFormRef>(null);

  const onCabysSelected = (product?: ProductDataType) => {
    const categoryData: CategoryDataType = {
      codigo_cabys: product?.codigo_cabys,
      porcentaje_impuesto: product?.porcentaje_impuesto,
      tipo_impuesto: product?.tipo_impuesto,
      tipo_producto: product?.tipo_producto

    }
    formRef.current?.setFormValue("multipleData", categoryData, "multipleData")
  }

  return (
    <>
      <GenericForm<CategoryFormData, CategoryDataType>
        id={props.id}
        ref={formRef}
        formId={props.formId}
        saveRedirectUrl={props.saveRedirectUrl}
        formConfig={CategoryFormConfig}
        getNextCode={() => CategoryApi.getNextCode("codigo")}
        getById={(...arg) => CategoryApi.get(...arg)}
        createFn={(...arg) => CategoryApi.create(...arg)}
        updateFn={(...arg) => CategoryApi.update(...arg)}
        successMessage="La Categoria ha sido almacenada correctamente"
        errorMessage="No fue posible almacenar la información de la Categoria"
      />

      <SearchCabysOffCanvas
        onCabysSelected={onCabysSelected} />
    </>
  )
}

export default CategoryForm;